export const type = 'session/update';

export default payload => ({
  type,
  error: false,
  payload,
});
